import type { SelectedJurisdiction } from "../../review/types/jurisdiction.types";

/**
 * Maps stored local-jurisdiction filter rows to API `certificateJurisdictionCodes`
 * (customer search, certificate search, exports).
 * Rows use {@link SelectedJurisdiction} — same as TPS / add-certificate (`code`, `name`, `type`, `regionInitial`, `regionName`).
 * Uses **`code` only** for the API list; region is display / dropdown identity, not sent on this property.
 * Empty selection yields `[]`; APIs that default this field to null treat that the same for filtering.
 */
export function mapLocalJurisdictionsToCertificateJurisdictionCodes(
    items: SelectedJurisdiction[] | undefined
): string[] {
    if (!items?.length) {
        return [];
    }
    const codes = items.map(j => (j.code || "").trim()).filter(Boolean);
    return [...new Set(codes)];
}
